<template>
    <console-content max-width="1024">

        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="tit tit--lg">
                <span v-if="banner._id">배너 상세</span>
                <span v-else>배너 등록</span>
            </v-col>
            <v-spacer/>
        </v-row>

        <v-row class="mt-3">
            <v-col cols="12" md="8"  class="py-0 pr-md-1">
                <v-card class="mx-1" :disabled="!$hasScope(['root', 'admin'])">
                    <v-card-title class="tit tit--xs font-weight-bold">기본정보</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field v-model="banner.subject" label="제목" persistent-placeholder hide-details />
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field v-model="banner.url" label="url" persistent-placeholder hide-details />
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field v-model="banner.no" label="순서" persistent-placeholder hide-details />
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                                <v-select v-model="banner.type" :items="typeItems" label="타입" persistent-placeholder hide-details />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="4" class="py-0 pl-md-1">
                <v-card class="mx-1 mt-3 mt-md-0" :disabled="!$hasScope(['root', 'admin'])">
                    <v-card-title>
                        <span class="tit tit--xs">url 속성(내부 / 외부)</span>
                        <v-spacer/>
                        <v-switch v-model="banner.isUrl" hide-details class="mt-0"/>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>

        <v-card class="mt-4 mx-1" :disabled="!$hasScope(['root', 'admin'])">
            <v-card-title class="tit tit--xs font-weight-bold">배너 이미지</v-card-title>
            <v-card-text>
                <v-layout no-gutters align-center>
                    <v-img v-if="image" :src="image" max-width="96" height="auto" contain></v-img>
                    <v-sheet v-else width="96" height="96" color="d-flex justify-center align-center grey lighten-2"><v-icon>mdi-image</v-icon></v-sheet>
                    <v-file-input v-model="banner.image" />
                </v-layout>
            </v-card-text>
        </v-card>

        <v-row class="my-6">
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn :disabled="!$hasScope(['root', 'admin'])" color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

    </console-content>
</template>

<script>
import api from "@/api";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";

export default {
    components: {
        ConsoleContent,
        NaverSmarteditor
    },
    data(){
        return {
            banner: {
                _id: this.$route.params._banner
            },
            typeItems: [
                { text: "PC", value: "pc" },
                { text: "MOBILE", value: "mobile" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            if(this.banner._id){
                let { banner } = await api.console.common.banners.get(this.banner);
                if (banner.isUrl) banner.url = banner.open
                if (!banner.isUrl) banner.url = banner.to
                if (banner.imgae) banner.imgae = await api.getResource(banner.imgae)
                this.banner = banner;
            }
        },
        async save(){
            let { banner } = this.banner._id ? await api.console.common.banners.put({...this.banner}) : await api.console.common.banners.post({...this.banner});
            
            if(this.image){
                let { image } = await api.console.common.banners.image.post(banner._id, this.banner.image);
                banner.image = image;
            }
            
            alert("저장되었습니다");
            this.$router.go(-1);
        }
    },
    computed: {
        image(){
            try{
                return URL.createObjectURL(this.banner.image);
            }
            catch(error){
                return null;
            }
        },
    }
}
</script>